/**
 * Epics or Stories for pickers: only rows in the same sprint as the task/story being edited.
 * When sprintId is empty (backlog / no sprint), only items with no sprint are listed.
 */
export function filterEpicsForSprintPicker(epics, sprintId) {
  const raw = Array.isArray(epics) ? epics : [];
  const sid = sprintId != null && String(sprintId).trim() !== '' ? String(sprintId) : '';
  if (!sid) {
    return raw.filter(
      (ep) => ep.sprint_id == null || ep.sprint_id === '' || String(ep.sprint_id).trim() === '',
    );
  }
  return raw.filter((ep) => String(ep.sprint_id ?? '') === sid);
}
